
import { Eye, X } from "react-feather";
import styles from "../../../leaderboard.module.css";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import { Dialog, DialogContent } from "@mui/material";
import dayjs from "dayjs";

const ProfileTab = ({ currentApplicantData, setLoading }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [docUrl, setDocUrl] = useState("");
    const [openDocModal, setOpenDocModal] = useState(false);

    const viewDocument = async (prospectId) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/get-identity-file/" + prospectId, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);
            setOpenDocModal(true);
            setDocUrl(response.data.data);
        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    const openTenantReportFile = async (applicantId) => {
        setLoading(true);
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.get(process.env.REACT_APP_APPLICANT_API_URL + "v1/get-report-link/" + applicantId, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then((response) => {
            setLoading(false);
            window.open(response?.data?.url);
        }).catch((error) => {
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<>
        <div className={`${styles.ProfileRow}`}>
            <div className={`${styles.ProfileConSec}`}>
                <div className={`${styles.SMScoreCardDe}`}>
                    <p className={`${styles.SMScoreCardDeTitle}`}>Personal Information</p>
                    <ul>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Referral:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.referral_name !== "" ? currentApplicantData?.referral_name : "-"}</span>
                        </li>
                        {currentApplicantData?.document_type !== "" && (<li>
                            <span className={`${styles.SMProDETag}`}>Verification:</span>
                            <a href="/" className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); viewDocument(currentApplicantData?.id); }}>
                                <Eye />
                                {currentApplicantData?.document_type === "passport" && "Passport"}
                                {currentApplicantData?.document_type === "id_card" && "Id Card"}
                                {currentApplicantData?.document_type === "driving_license" && "Driver License"}
                            </a>
                        </li>)}
                        <li>
                            <span className={`${styles.SMProDETag}`}>Credit Score:</span>
                            <span className={`${styles.SMProDE}`}>
                                {currentApplicantData?.reportPDF !== "" ? <><a href="/" className={`${styles.SMProDE}`} onClick={(e) => { e.preventDefault(); openTenantReportFile(currentApplicantData?.id); }}><Eye />{currentApplicantData?.credit_score}</a><img src="/static/img/verified.svg" className={`${styles.Varified}`} alt="" /></> : (currentApplicantData?.credit_score !== "" ? currentApplicantData?.credit_score : "-")}
                            </span>
                        </li>
                        {currentApplicantData?.income_type === "Voucher" ? (<li>
                            <span className={`${styles.SMProDETag}`}>Voucher:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.voucher_amount !== "" ? currentApplicantData?.voucher_amount : "-"}</span>
                        </li>) : (<li>
                            <span className={`${styles.SMProDETag}`}>Salary:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.income_per_year !== "" ? "$" + currentApplicantData?.formatted_income_per_year : "-"}</span>
                        </li>)}
                        <li>
                            <span className={`${styles.SMProDETag}`}>Bankruptcy:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.ever_had_bankruptcy !== "" ? currentApplicantData?.ever_had_bankruptcy
                                : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Housing Court Cases:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.ever_case_filed !== "" ? currentApplicantData?.ever_case_filed : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Current Monthly Rent:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.current_rent !== "" ? "$" + currentApplicantData?.formatted_current_rent : "-"}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={`${styles.ProfileConSec}`}>
                <div className={`${styles.SMScoreCardDe}`}>
                    <p className={`${styles.SMScoreCardDeTitle}`}>Preferences</p>
                    <ul>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Move-In Date:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.move_in_date !== "" ? dayjs(currentApplicantData?.move_in_date).format("MM/DD/YYYY") : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Bedrooms:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.bedrooms !== "" ? currentApplicantData?.bedrooms : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Bathrooms:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.bathrooms > 0 ? currentApplicantData?.bathrooms : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Pets:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.have_pets !== "" && currentApplicantData?.have_pets !== "0" ? currentApplicantData?.have_pets : "-"}</span>
                        </li>
                        <li>
                            <span className={`${styles.SMProDETag}`}>Smoke:</span>
                            <span className={`${styles.SMProDE}`}>{currentApplicantData?.do_you_smoke !== "" ? currentApplicantData?.do_you_smoke : "-"}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        

        <Dialog
            onClose={(e) => { setOpenDocModal(false); setDocUrl(""); }}
            aria-labelledby="customized-dialog-title"
            open={openDocModal}
            className="NewPopUp NewPopUpForLease"
        >
            <button onClick={(e) => { setOpenDocModal(false); setDocUrl(""); }} className={`${styles.IDImageCloseBU}`}><X /></button>
            <DialogContent>
                <div className={`${styles.IDImageSec}`}>
                    <img src={docUrl} className={`${styles.IDImage}`} alt="" />
                </div>
            </DialogContent>
        </Dialog>
    </>);
}

export default ProfileTab;